import { storyblokEditable, renderRichText } from "@storyblok/react"
import { Button } from "../../ui/button"

export default function Hero({ blok }: any) {
  const html = (rt: any) =>
    (renderRichText(rt || { content: [] }) || "").toString()
  const toPlain = (rt: any) =>
    html(rt)
      .replace(/<[^>]+>/g, "")
      .replace(/\s+/g, " ")
      .trim()

  const hasProgramDates = !!toPlain(blok?.programDates)
  const hasDeadline = !!toPlain(blok?.registrationDeadline)
  const ctaText = toPlain(blok?.ctaText) || "Join Waitlist"

  return (
    <section
      {...storyblokEditable(blok)}
      className="relative overflow-hidden bg-gradient-to-b from-[#EEF1FF] via-white to-white"
    >
      <div className="pointer-events-none absolute -top-40 left-[-10%] h-[35rem] w-[35rem] rounded-full bg-gradient-to-br from-[#C7D2FF] via-transparent to-transparent blur-[150px] opacity-60" />
      <div className="pointer-events-none absolute -bottom-40 right-[-10%] h-[30rem] w-[30rem] rounded-full bg-gradient-to-tl from-[#D6E0FF] via-transparent to-transparent blur-[150px] opacity-60" />

      <div className="relative max-w-6xl mx-auto px-6 md:px-12 py-14 md:py-18">
        <div className="mb-8 md:mb-10">
          <h1
            className="font-['BeausiteClassic'] font-bold text-[36px] leading-[1.1] md:text-[56px] md:leading-[1.05] text-gray-900 text-center"
            dangerouslySetInnerHTML={{ __html: html(blok.headline) }}
          />
        </div>

        <div className="grid md:grid-cols-2 gap-32 items-start relative overflow-visible">
          <div className="relative z-[1]">
            <div className="pointer-events-none absolute left-[-12px] md:left-[-16px] top-6 bottom-6 w-2 rounded-full bg-gradient-to-b from-[#4750F5] to-[#8BA3FF]" />
            <div className="bg-white/60 backdrop-blur-xl border border-white/40 shadow-[0_8px_40px_rgba(71,80,245,0.12)] rounded-3xl px-6 md:px-8 py-8">
              <div
                className="font-['BeausiteClassic'] text-base md:text-lg text-gray-800 mb-4"
                dangerouslySetInnerHTML={{ __html: html(blok.subheadline) }}
              />
              <div
                className="font-['BeausiteClassic'] text-base md:text-lg text-gray-700 leading-relaxed mb-6"
                dangerouslySetInnerHTML={{ __html: html(blok.blurb) }}
              />

              {(hasProgramDates || hasDeadline) && (
                <div className="flex flex-wrap gap-3 mb-6">
                  {hasProgramDates && (
                    <span
                      className="text-[13px] md:text-sm font-medium tracking-wide text-[#4750F5] bg-[#F6F7FF] border border-[#E4E8FF] px-4 py-1 rounded-full"
                      dangerouslySetInnerHTML={{
                        __html: html(blok.programDates),
                      }}
                    />
                  )}
                  {hasDeadline && (
                    <span
                      className="text-[13px] md:text-sm font-medium tracking-wide text-[#4750F5] bg-[#F6F7FF] border border-[#E4E8FF] px-4 py-1 rounded-full"
                      dangerouslySetInnerHTML={{
                        __html: html(blok.registrationDeadline),
                      }}
                    />
                  )}
                </div>
              )}

              {ctaText && (
                <a
                  href={blok.ctaLink?.url || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button variant="default" size="lg">
                    {ctaText}
                  </Button>
                </a>
              )}
            </div>
          </div>

          <div className="relative z-[1] flex items-start overflow-visible mt-10">
            {blok?.heroImage?.filename && (
              <div className="relative inline-block md:ml-2">
                <div
                  className="
                    absolute
                    -right-8 md:-right-12
                    -bottom-8 md:-bottom-12
                    w-[115%] md:w-[120%]
                    h-[55%] md:h-[60%]
                    bg-[#FCB900]
                    rotate-6
                    rounded-2xl
                    shadow-[0_18px_40px_rgba(252,185,0,0.35)]
                    z-[1]
                  "
                />
                <div
                  className="
                    absolute
                    -top-6 -left-6
                    w-40 h-40
                    rounded-full
                    bg-[#DDE2FF]
                    blur-2xl
                    opacity-80
                    z-[1]
                  "
                />
                <img
                  src={blok.heroImage.filename}
                  alt={blok.heroImage.alt || "Concierge Program"}
                  className="relative z-[2] w-full max-w-[520px] md:max-w-[560px] object-cover rounded-3xl shadow-xl"
                  loading="eager"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
